import Vue from 'vue';
import VueRouter from 'vue-router';

import AuthPage from 'components/page/AuthPage.vue';
import ResetPasswordPage from 'components/page/ResetPasswordPage.vue';
import RecoverPasswordPage from 'components/page/RecoverPasswordPage.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/login/',
  },
  {
    path: '/login/',
    name: 'login',
    component: AuthPage,
  },
  {
    path: '/signup/',
    name: 'signup',
    component: AuthPage, // NOTE: because of using AuthPage as login and as signup pages
  },
  {
    path: '/reset-password/',
    name: 'reset-password',
    component: ResetPasswordPage,
  },
  {
    path: '/recover-password/',
    name: 'recover-password',
    component: RecoverPasswordPage,
  },
];

const Router = new VueRouter({
  mode: 'history',
  routes,
  base: `${process.env.BASE_URL}auth/`,
});

export default Router;
